<!-- <ngx-loading-bar [color]="'#7366ff'" [includeSpinner]="false" [height]="'4px'"></ngx-loading-bar>-->
<!-- <app-loader></app-loader>-->
<app-license-banner></app-license-banner>
<app-tap-to-top></app-tap-to-top>
<router-outlet></router-outlet>
<!-- ZONE GLOBALE D’IMPRESSION -->
<div id="print-root"></div>
